import React from 'react';

import dashboardCss from '@kit/sidebar/dashboard.module.css';

type Props = {
	children: React.ReactNode;
	/** уточнение под названием: «3-й круг, Эвокация», тип чудовища; без него остаётся один заголовок */
	subTitle?: React.ReactNode;
};

export const PageTitle: React.FC<Props> = ({children, subTitle}) => (
	<hgroup className={dashboardCss.titleGroup}>
		<h1>{children}</h1>
		{subTitle && <p className="subTitle">{subTitle}</p>}
	</hgroup>
);
